export const DiscountRequestState = {
    None: 0,
    Requested: 1,
    Canceled: 2,
    Approved: 3,
    Declined: 4
} as const;

export type DiscountRequestState = typeof DiscountRequestState[keyof typeof DiscountRequestState];